<div class="new-insured-page about-banner">
  <div class="container">
    <div class="banner-section">
      <div class="about-banner-logo-aniamte">
        <img src="./assets/img/logo_blue.png" alt="About Banner" class="logo_blue">
        <img src="./assets/img/logo_card_hd.png" width="288" height="477" alt="About Banner" class="logo_card">  
        <div class="logo_assist_wrapper">
        <img src="./assets/img/logo_assist.png" alt="About Banner" class="logo_assist">
        <img src="./assets/img/logo_by_BAC_financial.png" alt="About Banner" class="logo_bac">
      </div>
      </div>
      <!-- <img src="./assets/img/about-banner.png" alt="About Banner" class="mobile-none">
      <img src="./assets/img/mobile-about-banner.png" alt="About Banner" class="web-none"> -->
    </div>
    <div class="banner-sub-heading">
      <span>Blue Assist Corporation, forma parte del grupo BAC Financial, compañía líder en el mercado internacional de seguros, con más de 30 años de experiencia.</span>
      <a href="https://bacfinancial.biz" class="banner-btn" target="_blank">Más de BAC Financial</a>
    </div>
    <div class="scroll-link mobile-none">
      <a (click)="scrollTo('forBox')" class="forBox mb-3">
        <!-- <img src="./assets/img/scroll-down-arrow.png"/> -->
        <div class="arrow-down-button">
          <svg class="bouncing-arrow-down" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
            <g>
              <path d="M230.4,424.8V25.6C230.4,11.5,241.9,0,256,0c14.1,0,25.6,11.5,25.6,25.6v399.2l135.7-135.7c10.8-9.1,27-7.8,36.1,3   c8.2,9.6,8.1,23.8-0.2,33.3L273.9,504.7c-10,9.8-25.9,9.8-35.8,0L58.8,325.4c-9.3-10.7-8.2-26.8,2.5-36.1   c9.5-8.3,23.7-8.4,33.3-0.2L230.4,424.8z"/>
            </g>
            </svg>
        </div>
      </a>
    </div>
  </div>
</div> 
<section class="forBox-page"  >
<div class="container fourBoxSectionContainer">  
  <div class="for-box-section about-for-box-section fourBoxSection" #fourBoxSection>
    <div class="row">
      <div class="col-md-3" id="four-box1">
        <div class="box-section lgray-box">
          <h2><em class="accent">Liderazgo</em> en el mercado</h2>
          <p>Tenemos un amplio conocimiento y experiencia en el mercado, lo que nos permite ofrecer Planes de Asistencia con beneficios adecuados a la necesidad del Viajero.</p>
        </div>
      </div>
      <div class="col-md-3" id="four-box2">
        <div class="box-section white-box">
          <!-- <img [attr.src]="'/assets/external/Location-Blue.png'" class="img-fluid" style="height: 135px"/> -->
          <h2><em class="accent">Confianza</em> en cada viaje</h2>
          <p>Nuestros valores de integridad, ética y honestidad garantiza que nuestros clientes se sientan protegidos durante su viaje.</p>
        </div>
      </div>
      <div class="col-md-3" id="four-box3">
        <div class="box-section blue-box">
          <h2><em class="accent">Solidez</em> financiera</h2>
          <p>Contamos con solidez financiera y respaldo de destacados reaseguradores a nivel Internacional.</p>
        </div>
      </div>
      <div class="col-md-3" id="four-box4">
        <div class="box-section dgray-box">
          <h2>Servicio <em class="accent">24 horas</em></h2>
          <p>Brindamos servicio 24/7 para asistencia al viajero o emergencia medica que se presente durante el viaje.</p>
        </div>
      </div>
    </div>
  </div>
</div>
</section>
<!-- Beneficios Blue Assist -->
<div class="beneficios-blue-assist about-beneficios-blue" id="forBox">
  <div class="container beneficios-container">
    <div class="row">
      <div class="col-md-6">
        <div class="beneficios-left-section">
          <span class="join-k">Red de ventas</span>
          <h1>Únete a <em class="accent">nuestro equipo</em> en Blue Assist</h1>
          <p>Déjanos tus datos y sé parte de nuestra red de ventas. Juntos impulsaremos tu éxito con las mejores oportunidades y el respaldo que necesitas.</p>
          <button type="button" class="btn btn-primary continue-btn-steps" style="max-width: 160px;" data-bs-toggle="modal" data-bs-target="#joinUsModal">
            Unirse ahora
        </button>
          
        </div>
      </div>
      <div class="col-md-6">
        <div class="beneficios-right-section">
          <img src="/assets/img/big-logo.png" alt="Blue Assist" class="big-logo">
          <img src="/assets/img/beneficios-lady.png" alt="Blue Assist" class="beneficios-lady">
        </div>
      </div>
    </div>
  </div>
</div> 
<!-- Beneficios Blue Assist -->  

<!-- Modal -->
<div class="modal fade" id="joinUsModal" tabindex="-1" aria-labelledby="joinUsModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Unirse al programa</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
  
          <div *ngIf="!emailSendingStatus || emailSendingStatus == 0">
            <div class="row" >
              <p>
                Si usted esta interesado en pertenecer a nuestro equipo de Representantes, favor complete la siguiente información:
              </p>
            </div>
            <form [formGroup]="joinUsForm">
              <div class="form-group">
                <label for="agentName" class="label-form-style">Nombre completo *</label>
                <input type="text" class="form-control input-form-full-space" formControlName="agentName" id="agentName">
              </div>
              <div class="form-group">
                <label for="agentEmail" class="label-form-style">Correo electrónico *</label>
                <input type="text" class="form-control input-form-full-space" formControlName="agentEmail" id="agentEmail">
              </div>
              <div class="form-group">
                <label for="agentCountry" class="label-form-style">País *</label>
                <select name="miselect" formControlName="agentCountry" id="agentCountry" class="p-dropdown">
                  <option [value]="item.text" *ngFor="let item of countries">{{item.text}}</option>
                </select> 
              </div>
              <div class="form-group">
                <label for="agentPhone" class="label-form-style">Teléfono *</label>
                <input type="text" class="form-control input-form-full-space" formControlName="agentPhone" id="agentPhone">
              </div>
            </form>
          </div>
  
          <div class="row" *ngIf="emailSendingStatus == 1">
            <div class="col-12 text-center">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
  
          <div class="row" *ngIf="emailSendingStatus == 2">
            <div class="col-12">
              <div class="alert alert-success" role="alert">
                <strong>Mensaje entregado.</strong> Gracias por confiar en nosotros.
              </div>
            </div>
          </div>
  
          <div class="row" *ngIf="emailSendingStatus == 3">
            <div class="col-12">
              <div class="alert alert-danger" role="alert">
                <strong>Mensaje no entregado.</strong> Por favor, intente nuevamente más tarde.
              </div>
            </div>
          </div>
  
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
          <button type="button" [disabled]="canContinue!=true" class="btn btn-primary" (click)="sendInvitationEmail()">Enviar</button>
        </div>
      </div>
    </div>
  </div>